module.exports = "<p>\r\n  contact works!\r\n</p>\r\n"